/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import UploadImage from "../src/components/upload/uploadFile";
import { useDispatch, useSelector } from "react-redux";
import {
  addBackground,
  addBackgroundColor,
  addBackgroundSelectedImg,
  resetUploadedFile,
  selecBgToAdd,
  selectedColor,
  selectedImage,
  selectStatus,
  selectUploadedFile,
  selecUploadedImage,
} from "../src/Redux/uploadFile/UploadFileSLice";
import ResultImage from "../src/components/upload/resultImage";
import ColorPopover from "../src/components/popoverAddBG/colorPopover";
import BackgroundPopover from "../src/components/popoverAddBG/imagesPopover";
import DownloadBtn from "../src/components/upload/DownloadBtn";
import ShowMgsInfo from "../src/components/showMsgInfo";
import ResetButton from "../src/components/upload/resetButton";
import { showAlert } from "../src/Redux/alert/alertSlice";
import ShowBannerInfo from "../src/components/showBannerInfo";
import {
  fetchUserProfile,
  logout,
  selectisauth,
} from "../src/Redux/user/UserSlice";
import { showLogoutModal } from "../src/Redux/alert/modalLogoutSlice";
import { NextSeo } from "next-seo";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "../src/config/Store";
import Head from "next/head";
import CustomModal from "../src/components/CustomModal";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import DynamicTitle from "../src/components/DynamicTitle";
import ThumbRating from "../src/components/rating/ThumbRating";
const COMPONENT_NAMES = {
  ADD_BG_IMAGE_PAGE: "AddBackgroundPage",
};
const AddBackground = () => {
  const { t } = useTranslation();

  const [width, setWidth] = useState(660);
  const [height, setHeight] = useState(250);
  const images = useSelector(selectUploadedFile);
  const bgToAdd = useSelector(selecBgToAdd);
  const selectedColorToAdd = useSelector(selectedColor);
  const selectedImageToADD = useSelector(selectedImage);
  const isauth = useSelector(selectisauth);
  const status = useSelector(selectStatus);
  const resultImg = useSelector(selecUploadedImage);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    resetUploadedFile;
    dispatch(resetUploadedFile());
    return () => {
      dispatch(resetUploadedFile());
    };
  }, [dispatch]);
  const [rating, setRating] = useState();
  const [ratingCompleted, setRatingCompleted] = useState(true); 
  const handleRatingChange = (newRating) => {
    setRating(newRating); // Mettre à jour la note dans l'état
    setRatingCompleted(false);
  };
  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (token) {
      dispatch(fetchUserProfile()).then((response) => {
        if (
          response.payload?.code === "4002" ||
          response.payload?.code === "4004"
        ) {
          dispatch(logout());
        }
      });
    }
  }, [dispatch]);

  const handleAddBg = () => {
    const formData = new FormData();
    formData.append("image", images);
    
    if (!bgToAdd && !selectedColorToAdd && !selectedImageToADD) {
      dispatch(
        showAlert({
          message: t('addBackgroundPage.alerts.chooseBackground'),
          color: "danger",
        })
      );
      return;
    }
    

    if (bgToAdd) {
      formData.append("background_image", bgToAdd);
      dispatch(addBackground(formData)).then((response) => {

        try{
          if (response?.payload?.code === "2011") {
            dispatch(
              showAlert({
                message: t('addBackgroundPage.alerts.loginRequired'),
                color: "danger",
              })
            );
            setShowAuthModal(true);
  
            return; 
          }
          switch (response?.payload?.code) {
            case "2000":
              setRatingCompleted(true);
              break;
            case "2005":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.noSubscription'),
                  color: "danger",
                })
              );
              break;
            case "2001":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.loginRequired'),
                  color: "danger",
                })
              );
              break;
  
            case "2006":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.expiredSubscription'),
                  color: "danger",
                })
              );
              break;
            case "5000":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.serviceUnavailable'),
                  color: "danger",
                })
              );
              break;
            default:
              if (response?.error?.message === "Rejected") {
                dispatch(
                  showAlert({
                    message: t('addBackgroundPage.alerts.serviceUnavailable'),
                    color: "danger",
                  })
                );
              }
          }
        }
        catch (error) {
          dispatch(
            showAlert({
              message: t('addBackgroundPage.alerts.serviceUnavailable'),
              color: "danger",
            })
          );
        }
       
      });
    } else if (selectedColorToAdd) {
      formData.append("background_color", selectedColorToAdd);
      dispatch(addBackgroundColor(formData)).then((response) => {
        try{
          if (response?.payload?.code === "2011") {
            dispatch(
              showAlert({
                message: t('addBackgroundPage.alerts.loginRequired'),
                color: "danger",
              })
            );
            setShowAuthModal(true);
  
            return; 
          }
          switch (response?.payload?.code) {
            case "2000":
              setRatingCompleted(true);
              break;

            case "2005":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.noSubscription'),
                  color: "danger",
                })
              );
              break;
            case "2006":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.expiredSubscription'),
                  color: "danger",
                })
              );
              break;
            case "5000":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.serviceUnavailable'),
                  color: "danger",
                })
              );
              break;
            default:
              if (response?.error?.message === "Rejected") {
                dispatch(
                  showAlert({
                    message: t('addBackgroundPage.alerts.serviceUnavailable'),
                    color: "danger",
                  })
                );
              }
          }
        }
        catch (error) {
          dispatch(
            showAlert({
              message: t('addBackgroundPage.alerts.serviceUnavailable'),
              color: "danger",
            })
          );
        }
        
      });
    } else if (selectedImageToADD) {
      formData.append("background_name", selectedImageToADD);
      dispatch(addBackgroundSelectedImg(formData)).then((response) => {

        try{
          if (response?.payload?.code === "2011") {
            dispatch(
              showAlert({
                message: t('addBackgroundPage.alerts.loginRequired'),
                color: "danger",
              })
            );
            setShowAuthModal(true);
  
            return; 
          }
          switch (response?.payload?.code) {
            case "2000":
              setRatingCompleted(true);
              break;
              
            case "2005":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.noSubscription'),
                  color: "danger",
                })
              );
              break;
            case "2006":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.expiredSubscription'),
                  color: "danger",
                })
              );
              break;
            case "5000":
              dispatch(
                showAlert({
                  message: t('addBackgroundPage.alerts.serviceUnavailable'),
                  color: "danger",
                })
              );
            default:
              if (response?.error?.message === "Rejected") {
                dispatch(
                  showAlert({
                    message: t('addBackgroundPage.alerts.serviceUnavailable'),
                    color: "danger",
                  })
                );
              }
          }
        }
        catch (error) {
          dispatch(
            showAlert({
              message: t('addBackgroundPage.alerts.serviceUnavailable'),
              color: "danger",
            })
          );
        }
      
      });
    }
  };
  const clearImage = () => {
    dispatch(selectedImage(null)); // Clear selected image in Redux state
  };

  const clearColor = () => {
    dispatch(selectedColor(null)); // Clear selected color in Redux state
  };

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: t("schemaData.addbgname"),
    description:t("schemaData.addbgdescription"),
    url: process.env.NEXT_PUBLIC_BASE_URL + "/add-background",
    image: BASE_URL + "/images/LandingPage/add-background.svg",
    author: {
      "@type": "Organization",
      name: "Pixeloop",
      url: BASE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: "Pixeloop",
      logo: {
        "@type": "ImageObject",
        url: BASE_URL + "/images/Logo/pixeloop-logo.svg",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": BASE_URL + "/add-background",
    },
    potentialAction: {
      "@type": "Action",
      name:  t("schemaData.addAction"),
      target: {
        "@type": "EntryPoint",
        urlTemplate: BASE_URL + "/add-background",
      },
    },
  };
  return (
    <div className="upcontainer">
      <Head>
        {/* JSON-LD for structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>
      <ShowBannerInfo />
      {!isauth &&  showAuthModal && <CustomModal />}
    <ShowMgsInfo />
    <DynamicTitle
        title="Add Stunning Backgrounds or Colors to Images"
        subtitle="Transform Your Images with Custom Backgrounds in Seconds"
        titleClass="fs-34"
        subtitleClass="fs-22"
      />
      <div className="pr-4 uploadContainer">
        {images?.name ? <ResultImage /> : <UploadImage />}
        <div className="controls-section">
          <div className="add-bg-controls">
            <div className=" d-flex flex-column resize-header">
              <div>
                <BackgroundPopover
                  popoverId="backgroundPopover"
                  data-text={t('addBackgroundPage.buttons.background')}

                  buttonLabel={t('addBackgroundPage.buttons.addBackground')}
                />
              </div>
              <div>
                <ColorPopover
                  popoverId="colorPopover"
                  buttonLabel={t('addBackgroundPage.buttons.addColor')}
                />
              </div>
            </div>

            <div className="add-bg-btn-container" style={{ marginTop: "50px" }}>
              <Button
                onClick={handleAddBg}
                className="w-100 actionButton "
                data-text={t("addBackgroundPage.buttons.apply")}

                disabled={images ? false : true}
              >
               {t('addBackgroundPage.buttons.addBackground')}
              </Button>
              <DownloadBtn />
              <ResetButton />
            </div>
          </div>
          <div>
        {resultImg && images && ratingCompleted &&
        <div className="display-flex">
          <h6 className="rate-title">Rate this result</h6>
          <ThumbRating value={rating} onChange={handleRatingChange} image={images}/>

        </div>
        
        
        
        
        }

        </div>
        </div>
      </div>
    </div>
  );
};
const AddBackgroundPage = () => {
  return (
    <PersistGate loading={null} persistor={persistor}>
      <AddBackground />
    </PersistGate>
  );
};
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
AddBackgroundPage.layout = "addBackground";
AddBackgroundPage.seo = {
  title:
    "Add Background to Images Instantly | AI-Powered Background Addition - pixeloop.io",
  description:
    "Easily add backgrounds to your images with our user-friendly tool. Choose from a variety of styles to create professional results in seconds. Perfect for professionals and small businesses, no technical skills required.",
  additionalMetaTags: [
    {
      name: "keywords",
      content:
        "Add background , Add background to images ,AI add background, Add bg, AI add bg, Image background addition, Background addition tool,add background tool, change background, AI image editor , Background addition tool,Add background API, Add background plugin , Add bg to images",
    },
    {
      name: "robots",
      content: "index,follow",
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content:
        "Add Background from Images in Seconds | Fast & Easy Background Addition",
    },
    {
      name: "twitter:description",
      content:
        "Add backgrounds from images instantly using our AI-powered tool. Get professional-looking results , plugin, or package for busineses in just a few seconds.",
    },
    {
      name: "twitter:image",
      content: BASE_URL + "/images/LandingPage/add-background.svg",
    },

    {
      name: "canonical",
      content: BASE_URL + "/add-background",
    },
  ],
  openGraph: {
    type: "website",
    description:
      "Easily add backgrounds to your images with our user-friendly tool. Choose from a variety of styles to create professional results in seconds. Perfect for professionals and small businesses, no technical skills required.",
    url: BASE_URL + "/add-background",
    title:
      "Add Background to Images Instantly | AI-Powered Background Addition - pixeloop.io",
    images: [
      {
        url: `${BASE_URL}/images/LandingPage/add-background.svg`,
        alt: "Pixeloop - Add background",
      },

      {
        url: `${BASE_URL}/images/LandingPage/add-image-categories.svg`,
        alt: "Pixeloop - Add Image Categories",
      },

      {
        url: `${BASE_URL}/images/Logo/pixeloop-logo.svg`,
        alt: "Pixeloop - logo",
      },
    ],
  },
};
AddBackgroundPage.displayName = COMPONENT_NAMES.ADD_BG_IMAGE_PAGE;

export default AddBackgroundPage;
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
